import { ReactComponent as AttachIcon } from 'mrg-icons/src/mailru/status/attach.svg';
import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { AttachItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Destination } from '../Destination';
import { Download } from '../Download';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Attach } from '../RowFor/Attach';
import { Size } from '../Size';

const AttachesItem = (props: AttachItemProps) => {
    const { onCheckboxClick, isSelected, isFolder, thumbUrl, ext, owner, name, subject, mtime, size, onDownload, id, storage } = props;
    const windowWidth = useWindowWidth();

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Attach {...props} checkboxClassname={newStyles.check} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic isFolder={isFolder} thumbUrl={thumbUrl} isVirus={false} ext={ext || ''} author={owner} />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} id={id} />
                            <Destination name={subject} icon={<AttachIcon />} />
                            <Date date={mtime} />
                            <Size size={size} />
                            <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <ItemName name={name} ext={ext || ''} id={id} />
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                    <Destination name={subject} icon={<AttachIcon />} noOverflow />
                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} />
                                    </span>
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    <Destination name={subject} icon={<AttachIcon />} />
                                    {mtime && <Date date={mtime} />}
                                    <Size size={size} />
                                </>
                            )}
                            <div className={styles.actionsWrapper}>
                                <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default AttachesItem;
